<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Estadísticas de Proyecciones</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <div class="col-lg-6 col-5 text-right">
          <button
            v-if="campaign"
            class="btn base-button btn-neutral btn-sm btn-wd mt-1"
            title="Descargar"
            @click="downloadPdf"
          >
            <i class="fas fa-download"></i>&nbsp;Descargar PDF
          </button>

          <button v-if="campaign" class="btn base-button btn-neutral btn-sm mt-1" @click="campaign = null">
            Cambiar Campaña
          </button>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">
      <div v-if="!campaign" class="row justify-content-center">
        <div class="col-md-6 col-sm-8 col-xs-12 card-wrapper">
          <div class="card mb-4">
            <div class="card-header">
              <h3 class="mb-0">Elija la campaña para ver estadisticas de los pedidos</h3>
            </div>
            <div class="card-body">
              <campaign-select v-model="campaign" />
            </div>
          </div>
        </div>
      </div>

      <div v-if="campaign" class="row">
        <div class="col-sm-12">
          <variety-campaign-totals-table
            v-if="type === 'variety'"
            ref="VarietyCampaignTotalsTable"
            :campaign="campaign"
          >
            <template slot="actions">
              <button class="btn btn-outline-primary btn-sm over-header" @click="type = 'crop'">
                <i class="fas fa-chart-bar"></i>&nbsp;Totales por cultivo
              </button>
              <button class="btn btn-outline-warning btn-sm over-header" @click="type = 'distributor'">
                <i class="fas fa-chart-bar"></i>&nbsp;Totales por distribuidor
              </button>
            </template>
          </variety-campaign-totals-table>
        </div>

        <div class="col-sm-12">
          <crops-totals-table v-if="type === 'crop'" ref="CropsTotalsTable" :campaign="campaign">
            <template slot="actions">
              <button class="btn btn-outline-dark btn-sm over-header" @click="type = 'variety'">
                <i class="fas fa-chart-bar"></i>&nbsp;Totales por variedad
              </button>
              <button class="btn btn-outline-warning btn-sm over-header" @click="type = 'distributor'">
                <i class="fas fa-chart-bar"></i>&nbsp;Totales por distribuidor
              </button>
            </template>
          </crops-totals-table>
        </div>

        <div class="col-sm-12">
          <distributors-totals-table v-if="type === 'distributor'" ref="DistributorsTotalsTable" :campaign="campaign">
            <template slot="actions">
              <button class="btn btn-outline-dark btn-sm over-header" @click="type = 'variety'">
                <i class="fas fa-chart-bar"></i>&nbsp;Totales por variedad
              </button>
              <button class="btn btn-outline-primary btn-sm over-header" @click="type = 'crop'">
                <i class="fas fa-chart-bar"></i>&nbsp;Totales por cultivo
              </button>
            </template>
          </distributors-totals-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import VarietyCampaignTotalsTable from './List/VarietyCampaignTotalsTable';
import CropsTotalsTable from './List/CropsTotalsTable';
import DistributorsTotalsTable from './List/DistributorsTotalsTable';
import CampaignSelect from '@/components/ModelSelects/CampaignSelect';
import CurrentCampaignMixin from '@/mixins/currentCampaignMixin';

export default {
  name: 'ProjectionsStats',
  components: {
    RouteBreadCrumb,
    VarietyCampaignTotalsTable,
    CropsTotalsTable,
    DistributorsTotalsTable,
    CampaignSelect,
  },

  mixins: [CurrentCampaignMixin],
  data() {
    return {
      type: 'variety',
    };
  },

  watch: {
    type(newValue) {
      this.$store.dispatch('navigation/setSelectedStat', newValue);
    },
  },

  created() {
    this.type = this.$store.state.navigation.statSelected || this.type;
  },

  methods: {
    downloadPdf() {
      switch (this.type) {
        case 'variety': {
          this.$refs.VarietyCampaignTotalsTable.downloadPdf();
          break;
        }
        case 'crop': {
          this.$refs.CropsTotalsTable.downloadPdf();
          break;
        }
        case 'distributor': {
          this.$refs.DistributorsTotalsTable.downloadPdf();
          break;
        }
        default: {
          break;
        }
      }
    },
  },
};
</script>

<style scoped>
::v-deep .over-header {
  z-index: 99999;
}
</style>
